/* LENS. · Selector de repuestos — lógica
   Pareja de sections/lens-selector-repuestos.liquid

   Por qué no usa /search/suggest.json: tope duro de 10 productos, ignora
   resources[limit]. RB2140 tiene 142 repuestos. Verificado 21-09-2026.
   Usa templates/search.repuestos.liquid, que pagina de a 50.
*/
(function () {
  var root = document.getElementById('lsr');
  if (!root || root.dataset.init) return;
  root.dataset.init = '1';

  var CFG = {};
  try { CFG = JSON.parse(document.getElementById('lsr-data').textContent); } catch (e) { return; }

  var $ = function (id) { return document.getElementById(id); };

  var ALT = CFG.alt || [];
  var NIVELES = CFG.niveles || [];
  var TIPO = CFG.tipo || 'Repuesto';
  var TAGS_CURVA = String(CFG.tagsCurva || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
  var PAGINAS_MAX = 6;
  var PISO_OUTLIER = 0.35;
  var TOPE_CODIGOS = 6;

  var PIEZAS = {
    L: { id: 'cristales', nombre: 'Cristales', ico: '👓' },
    V: { id: 'varillas', nombre: 'Varillas', ico: '🦯' },
    P: { id: 'plaquetas', nombre: 'Plaquetas nasales', ico: '👃' }
  };

  var S = {
    raw: [], modelo: null, pieza: null, medida: null,
    via: 'orig', grupo: null, item: null,
    nivel: null, colorSku: null,
    curvo: false, consulta: '', descartados: 0,
    filtro: '', verCodigos: false,
    marca: '', refs: 0
  };

  // Estilos de las piezas que crea el JS, y dos correcciones sobre la seccion.
  (function () {
    if (document.getElementById('lsr-css-js')) return;
    var st = document.createElement('style');
    st.id = 'lsr-css-js';
    st.textContent =
      '#lsr .lsr-filtro{position:relative;margin:14px 0 4px;}' +
      '#lsr .lsr-filtro input{width:100%;height:40px;padding:0 34px 0 12px;font-size:13px;' +
      'font-family:var(--lsr-body);color:var(--lsr-ink);background:#fff;border:1px solid var(--lsr-line);border-radius:0;outline:none;}' +
      '#lsr .lsr-filtro input:focus{border-color:var(--lsr-ink);}' +
      '#lsr .lsr-filtro input::placeholder{color:#A5A5A5;}' +
      '#lsr .lsr-filtro button{position:absolute;right:0;top:0;width:34px;height:40px;border:0;background:none;' +
      'cursor:pointer;font-size:20px;line-height:1;color:var(--lsr-soft);}' +
      '#lsr .lsr-vermas{display:block;width:100%;padding:11px;margin-top:4px;background:#FAFAFA;' +
      'border:1px dashed var(--lsr-line);cursor:pointer;font-family:var(--lsr-body);font-size:12px;' +
      'font-weight:600;letter-spacing:.3px;color:var(--lsr-mut);border-radius:0;}' +
      '#lsr .lsr-vermas:hover{border-color:var(--lsr-ink);color:var(--lsr-ink);}' +
      // La guia del codigo tenia DOS controles: el link "Donde encuentro el codigo"
      // y el <summary> "Ver donde esta el codigo". Dejamos solo el link.
      '#lsr details.lsr-guide > summary{display:none;}' +
      // .lsr-step:first-of-type nunca matcheaba: el primer <div> hijo es .lsr-h,
      // no el paso 1. Resultado: doble linea horizontal debajo del titulo.
      '#lsr .lsr-h + .lsr-step{border-top:0;margin-top:0;padding-top:26px;}';
    document.head.appendChild(st);
  })();

  // ---------- utilidades ----------

  function clp(n) { return '$' + Number(n).toLocaleString('es-CL'); }

  // El catalogo tiene mojibake: "CafŽ" por "Café", "DegradŽ" por "Degradé".
  function norm(s) {
    var t = String(s || '').replace(/Ž/g, 'e').replace(/ž/g, 'e');
    if (t.normalize) t = t.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return t.toLowerCase().replace(/[^a-z0-9 +-]/g, ' ').replace(/\s+/g, ' ').trim();
  }

  // ALE, 23-09-2026: norm() limpia el mojibake para COMPARAR (baja todo a minuscula y
  // saca acentos). Esto lo limpia para MOSTRAR, sin tocar nada mas del texto. Solo
  // mapeamos Ž -> é, que es el unico caso verificado en el catalogo ("DegradŽ",
  // "CafŽ"): es la é de Mac Roman leida como Windows-1252.
  function arreglarMojibake(s) { return String(s || '').replace(/Ž/g, 'é'); }

  var ACENTOS = {
    cafe: 'Café', degrade: 'Degradé', ambar: 'Ámbar', marron: 'Marrón',
    purpura: 'Púrpura', violeta: 'Violeta', turquesa: 'Turquesa',
    fotocromatico: 'Fotocromático', fotocromaticos: 'Fotocromáticos'
  };

  function titulo(s) {
    return String(s || '').split(' ').map(function (w) {
      if (ACENTOS[w]) return ACENTOS[w];
      return w.length > 2 && !/[0-9]/.test(w) ? w.charAt(0).toUpperCase() + w.slice(1) : w.toUpperCase();
    }).join(' ');
  }

  // REP-<PIEZA>-<MODELO>-<CODIGO DE COLOR>-<MEDIDA>
  function parseSku(sku) {
    var m = String(sku || '').match(/^REP-([A-Z]+)-([A-Z0-9]+)-(.+)-(\d{2,3})$/i);
    if (!m) return null;
    return { pieza: m[1].toUpperCase(), modelo: m[2].toUpperCase(), codigo: m[3], medida: m[4] };
  }

  function colorDe(t, modelo) {
    var s = String(t || '');
    var m = s.match(/\s+medida\s+\d+\s*$/i);
    if (m) s = s.slice(0, m.index);
    if (modelo) {
      var i = s.toUpperCase().lastIndexOf(modelo);
      if (i !== -1) s = s.slice(i + modelo.length);
    }
    s = s.replace(/^[\s·-]*((?:[A-Z0-9ÁÉÍÓÚÑ][A-Z0-9ÁÉÍÓÚÑ.-]*\s+)+)/, function (full) {
      return /[a-záéíóúñ]/.test(full) ? full : '';
    });
    return s.trim();
  }

  function esSoloCodigo(c) { return !c || /^[0-9][0-9A-Za-z]*$/.test(c.trim()); }

  function piezaDe(it) {
    var p = it.s && PIEZAS[it.s.pieza];
    if (p) return p.id;
    var t = norm(it.t);
    if (/cristal|lente/.test(t)) return 'cristales';
    if (/varilla|patilla/.test(t)) return 'varillas';
    if (/plaqueta|nasal|pad/.test(t)) return 'plaquetas';
    return 'otros';
  }

  // ALE, 23-09-2026: puente entre el id que guarda S.pieza ('cristales') y el nombre
  // legible. PIEZAS está indexado por la letra del SKU (L/V/P), no por id, así que
  // buscamos por .id igual que piezasDisponibles(), en vez de duplicar los nombres.
  function nombrePieza(id) {
    var out = '';
    Object.keys(PIEZAS).forEach(function (k) { if (PIEZAS[k].id === id) out = PIEZAS[k].nombre; });
    return out;
  }

  // ALE, 23-09-2026: la medida del SKU no se llama igual en todas las piezas. En un
  // cristal es el calibre; en una varilla es el largo. Decirle "calibre 150" a una
  // varilla de 150 mm es justamente el error que el bloque de confirmacion tiene que
  // evitar. Para plaquetas no tenemos un nombre verificado, asi que va "medida".
  function etiquetaMedida(pieza, valor) {
    if (!valor) return null;
    if (pieza === 'varillas') return { k: 'largo ', v: String(valor) };
    if (pieza === 'cristales') return { k: 'calibre ', v: String(valor) };
    return { k: 'medida ', v: String(valor) };
  }

  // ALE, 23-09-2026: el titulo del producto empieza con "2 Varillas de repuesto..." o
  // "2 Lentes de repuesto...". Ese 2 es el dato de que la referencia se vende por par:
  // lo leemos del catalogo en vez de suponerlo pieza por pieza.
  function esPar(it) { return /^\s*2\s/.test(String((it && it.t) || '')); }

  // El color listo para mostrar. Si el "color" del titulo es en realidad el codigo de
  // fabrica, no lo repetimos: ya va en su propio recuadro.
  function colorLindo(it) {
    if (!it || esSoloCodigo(it.color)) return '';
    return titulo(norm(it.color));
  }

  // Arma la linea de confirmacion. Cada parte es { pre, t, b }: pre va en texto plano
  // delante ("largo "), t es el dato y b lo pone en negrita. Las partes vacias se caen
  // solas, asi no queda nunca un " · " colgando.
  function pintarLinea(el, partes) {
    el.innerHTML = '';
    var primera = true;
    partes.forEach(function (p) {
      if (!p || !p.t) return;
      if (!primera) el.appendChild(document.createTextNode(' · '));
      primera = false;
      if (p.pre) el.appendChild(document.createTextNode(p.pre));
      if (p.b) {
        var b = document.createElement('b');
        b.textContent = p.t;
        el.appendChild(b);
      } else {
        el.appendChild(document.createTextNode(p.t));
      }
    });
  }

  // Los textos legales viven en settings, en texto plano. Aceptamos **asi** para poder
  // destacar la frase de la exclusion sin habilitar HTML dentro de un setting.
  function pintarNegritas(el, txt) {
    el.innerHTML = '';
    String(txt || '').split('**').forEach(function (trozo, i) {
      if (!trozo) return;
      if (i % 2) {
        var b = document.createElement('b');
        b.textContent = trozo;
        el.appendChild(b);
      } else {
        el.appendChild(document.createTextNode(trozo));
      }
    });
  }

  // ---------- traer resultados ----------

  function urlBusqueda(q, pag) {
    return '/search?q=' + encodeURIComponent(q + '* AND product_type:' + TIPO) +
      '&type=product&view=repuestos&page=' + pag;
  }

  function normalizar(x) {
    var s = parseSku(x.sku);
    return {
      vid: x.id, sku: x.sku, t: x.t, pesos: x.p, url: x.u, img: x.i, stock: x.a !== false,
      s: s,
      modelo: s ? s.modelo : '',
      medida: s ? s.medida : null,
      codigo: s ? s.codigo : '',
      color: colorDe(x.t, s ? s.modelo : '')
    };
  }

  function buscar(q) {
    q = String(q || '').trim();
    if (!q) return;

    S.consulta = q;
    S.raw = []; S.modelo = null; S.pieza = null; S.medida = null;
    S.via = 'orig'; S.grupo = null; S.item = null;
    S.nivel = null; S.colorSku = null; S.curvo = false; S.descartados = 0;
    S.filtro = ''; S.verCodigos = false;
    S.marca = ''; S.refs = 0;
    var fi = $('lsr-filtro'); if (fi) fi.value = '';

    var go = $('lsr-go');
    go.disabled = true; go.textContent = 'Buscando...';
    $('lsr-paso2').classList.remove('is-locked');
    $('lsr-paso3').classList.add('is-locked');
    $('lsr-aviso-curva').hidden = true;
    $('lsr-colores').innerHTML = '<div class="lsr-skel"></div><div class="lsr-skel"></div><div class="lsr-skel"></div>';
    resetSeleccion();

    fetch(urlBusqueda(q, 1))
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        var d = JSON.parse(txt);
        S.raw = (d.items || []).map(normalizar);
        go.disabled = false; go.textContent = 'Buscar';
        $('lsr-paso3').classList.remove('is-locked');
        elegirModeloInicial();
        pintarTodo();
        chequearCurva(q);

        var paginas = Math.min(d.pages || 1, PAGINAS_MAX);
        if (paginas > 1) {
          var pend = [];
          for (var i = 2; i <= paginas; i++) {
            pend.push(fetch(urlBusqueda(q, i)).then(function (r) { return r.text(); }).then(function (t) { return JSON.parse(t).items || []; }));
          }
          Promise.all(pend).then(function (packs) {
            packs.forEach(function (p) { S.raw = S.raw.concat(p.map(normalizar)); });
            elegirModeloInicial();
            pintarTodo();
          }).catch(function (e) { console.warn('[lsr] paginas extra', e); });
        }
      })
      .catch(function (e) {
        console.error('[lsr]', e);
        go.disabled = false; go.textContent = 'Buscar';
        $('lsr-colores').innerHTML = '';
        $('lsr-count').hidden = false;
        $('lsr-count').textContent = 'Hubo un error al buscar. Intenta de nuevo.';
      });
  }

  // ---------- modelos ----------

  function modelos() {
    var m = {};
    S.raw.forEach(function (x) { if (x.modelo) { m[x.modelo] = (m[x.modelo] || 0) + 1; } });
    var q = norm(S.consulta).replace(/[^a-z0-9]/g, '').toUpperCase();
    return Object.keys(m).map(function (k) {
      return { k: k, n: m[k], exacto: k === q, empieza: k.indexOf(q) === 0 };
    }).sort(function (a, b) {
      if (a.exacto !== b.exacto) return a.exacto ? -1 : 1;
      if (a.empieza !== b.empieza) return a.empieza ? -1 : 1;
      return b.n - a.n;
    });
  }

  function elegirModeloInicial() {
    var ms = modelos();
    if (!ms.length) { S.modelo = null; return; }
    if (!S.modelo || !ms.some(function (m) { return m.k === S.modelo; })) S.modelo = ms[0].k;
  }

  function delModelo() {
    return S.raw.filter(function (x) { return x.modelo === S.modelo; });
  }

  // ---------- piezas y medidas ----------

  function piezasDisponibles() {
    var c = {};
    delModelo().forEach(function (x) { var p = piezaDe(x); c[p] = (c[p] || 0) + 1; });
    return ['cristales', 'varillas', 'plaquetas'].map(function (id) {
      var def = null;
      Object.keys(PIEZAS).forEach(function (k) { if (PIEZAS[k].id === id) def = PIEZAS[k]; });
      return { id: id, nombre: def.nombre, ico: def.ico, n: c[id] || 0 };
    }).filter(function (p) { return p.n > 0; });
  }

  function medidasDisponibles() {
    var c = {};
    delModelo().filter(function (x) { return piezaDe(x) === S.pieza; })
      .forEach(function (x) { if (x.medida) c[x.medida] = (c[x.medida] || 0) + 1; });
    return Object.keys(c).sort(function (a, b) { return a - b; }).map(function (m) { return { m: m, n: c[m] }; });
  }

  // ---------- agrupacion por color ----------

  function grupos() {
    var base = delModelo().filter(function (x) {
      return piezaDe(x) === S.pieza && (!S.medida || x.medida === S.medida);
    });

    var g = {};
    base.forEach(function (x) {
      var solo = esSoloCodigo(x.color);
      var k = solo ? ('cod:' + norm(x.codigo)) : ('col:' + norm(x.color));
      if (!g[k]) g[k] = { k: k, soloCodigo: solo, nombre: solo ? x.codigo : x.color, items: [] };
      g[k].items.push(x);
    });

    var out = Object.keys(g).map(function (k) {
      var gr = g[k];
      var precios = gr.items.map(function (i) { return i.pesos; }).sort(function (a, b) { return a - b; });
      var mediana = precios[Math.floor(precios.length / 2)];
      var sanos = gr.items.filter(function (i) { return i.pesos >= mediana * PISO_OUTLIER; });
      S.descartados += (gr.items.length - sanos.length);
      if (!sanos.length) sanos = gr.items;

      var conFoto = sanos.filter(function (i) { return i.img; });
      var pool = conFoto.length ? conFoto : sanos;
      var rep = pool.slice().sort(function (a, b) { return a.pesos - b.pesos; })[0];

      var ps = sanos.map(function (i) { return i.pesos; });
      return {
        k: gr.k,
        soloCodigo: gr.soloCodigo,
        nombre: gr.soloCodigo ? gr.nombre : titulo(norm(gr.nombre)),
        items: sanos.slice().sort(function (a, b) { return a.pesos - b.pesos; }),
        rep: rep,
        min: Math.min.apply(null, ps),
        max: Math.max.apply(null, ps)
      };
    });

    return out.sort(function (a, b) {
      if (a.soloCodigo !== b.soloCodigo) return a.soloCodigo ? 1 : -1;
      if (b.items.length !== a.items.length) return b.items.length - a.items.length;
      return a.min - b.min;
    });
  }

  // ---------- regla de curva ----------

  function chequearCurva(q) {
    if (!TAGS_CURVA.length) return;
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var prods = (d.resources && d.resources.results && d.resources.results.products) || [];
        var urls = S.raw.map(function (r) { return String(r.url || '').split('?')[0]; });
        var armazon = prods.filter(function (p) { return urls.indexOf(p.url.split('?')[0]) === -1; })[0];
        if (!armazon) return;
        return fetch(armazon.url.split('?')[0] + '.js')
          .then(function (r) { return r.json(); })
          .then(function (pd) {
            var tags = (pd.tags || []).map(function (t) { return String(t).toLowerCase(); });
            S.curvo = TAGS_CURVA.some(function (t) { return tags.indexOf(t) !== -1; });
            pintarTodo();
          });
      })
      .catch(function () { });
  }

  // ---------- render ----------

  function pintarModelos() {
    var box = $('lsr-modelos');
    var ms = modelos();
    Array.prototype.slice.call(box.querySelectorAll('.lsr-chip')).forEach(function (c) { c.remove(); });
    if (ms.length < 2) { box.hidden = true; return; }
    box.hidden = false;
    ms.forEach(function (m) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lsr-chip' + (m.k === S.modelo ? ' on' : '');
      b.textContent = m.k + ' (' + m.n + ')';
      b.addEventListener('click', function () {
        S.modelo = m.k; S.pieza = null; S.medida = null; S.grupo = null;
        S.filtro = ''; S.verCodigos = false;
        var fi = $('lsr-filtro'); if (fi) fi.value = '';
        resetSeleccion(); pintarTodo();
      });
      box.appendChild(b);
    });
  }

  function pintarPiezas() {
    var box = $('lsr-piezas');
    box.innerHTML = '';
    var ps = piezasDisponibles();
    if (!ps.some(function (p) { return p.id === S.pieza; })) S.pieza = ps.length ? ps[0].id : null;

    ps.forEach(function (p) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lsr-pieza' + (p.id === S.pieza ? ' on' : '');
      b.innerHTML = '<span class="ico">' + p.ico + '</span><span><span class="nm"></span><span class="ct"></span></span>';
      b.querySelector('.nm').textContent = p.nombre;
      b.querySelector('.ct').textContent = p.n + (p.n === 1 ? ' opción' : ' opciones');
      b.addEventListener('click', function () {
        S.pieza = p.id; S.medida = null; S.grupo = null;
        S.via = 'orig'; // ALE, 22-09-2026: faltaba resetear la via; con 'alt' pegado el paso 3 quedaba sin ninguna lista.
        S.filtro = ''; S.verCodigos = false;
        var fi = $('lsr-filtro'); if (fi) fi.value = '';
        resetSeleccion(); pintarTodo();
      });
      box.appendChild(b);
    });
  }

  function pintarMedidas() {
    var box = $('lsr-calibres');
    Array.prototype.slice.call(box.querySelectorAll('.lsr-chip')).forEach(function (c) { c.remove(); });
    var ms = medidasDisponibles();
    // ALE, 23-09-2026: la etiqueta del grupo tambien cambia segun la pieza.
    var et = $('lsr-calibres-label');
    if (et) et.textContent = (S.pieza === 'varillas') ? 'Largo' : (S.pieza === 'cristales' ? 'Calibre' : 'Medida');
    if (ms.length < 2) { box.hidden = true; S.medida = null; return; }
    box.hidden = false;
    if (S.medida && !ms.some(function (x) { return x.m === S.medida; })) S.medida = null;
    ms.forEach(function (x) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lsr-chip' + (S.medida === x.m ? ' on' : '');
      b.textContent = x.m + ' mm';
      b.addEventListener('click', function () {
        S.medida = (S.medida === x.m) ? null : x.m;
        S.via = 'orig'; // ALE, 22-09-2026: misma razon que en pintarPiezas, al cambiar el calibre.
        S.grupo = null; resetSeleccion(); pintarTodo();
      });
      box.appendChild(b);
    });
  }

  // Caja para filtrar por el codigo grabado en la varilla. Se crea una sola vez.
  function cajaFiltro() {
    var ya = $('lsr-filtro-wrap');
    if (ya) return ya;
    var wrap = document.createElement('div');
    wrap.id = 'lsr-filtro-wrap';
    wrap.className = 'lsr-filtro';
    wrap.innerHTML =
      '<input type="text" id="lsr-filtro" placeholder="Filtrar por color o código (ej: Negro, 901)" autocomplete="off">' +
      '<button type="button" id="lsr-filtro-x" aria-label="Limpiar">×</button>';
    var drawer = $('lsr-orig-drawer');
    drawer.insertBefore(wrap, drawer.firstChild);
    var inp = wrap.querySelector('#lsr-filtro');
    inp.addEventListener('input', function () {
      S.filtro = norm(inp.value);
      S.verCodigos = !!S.filtro;
      pintarColores();
    });
    wrap.querySelector('#lsr-filtro-x').addEventListener('click', function () {
      inp.value = ''; S.filtro = ''; S.verCodigos = false; pintarColores(); inp.focus();
    });
    return wrap;
  }

  function coincide(g) {
    if (!S.filtro) return true;
    if (norm(g.nombre).indexOf(S.filtro) !== -1) return true;
    return g.items.some(function (i) { return norm(i.codigo).indexOf(S.filtro) !== -1; });
  }

  function pintarColores() {
    var box = $('lsr-colores');
    var cnt = $('lsr-count');
    box.innerHTML = '';
    S.descartados = 0;
    var todos = grupos();

    if (!todos.length) {
      cnt.hidden = false;
      cnt.textContent = 'No encontramos repuestos originales para esa combinación.';
      $('lsr-orig-precio').textContent = '—';
      $('lsr-orig-marca').hidden = true;
      S.marca = '';
      var w0 = $('lsr-filtro-wrap'); if (w0) w0.hidden = true;
      return;
    }

    var wrap = cajaFiltro();
    wrap.hidden = todos.length < 8;

    var gs = todos.filter(coincide);

    var totalSku = todos.reduce(function (a, g) { return a + g.items.length; }, 0);
    var min = Math.min.apply(null, todos.map(function (g) { return g.min; }));
    $('lsr-orig-precio').textContent = (totalSku === 1 ? '' : 'desde ') + clp(min);

    var marca = (todos[0].rep.t.match(/para\s+([A-Za-zÁÉÍÓÚÑáéíóúñ.-]+)/) || [])[1] || '';
    // ALE, 23-09-2026: la marca se usa tambien en la linea de confirmacion, no solo en
    // el badge, asi que queda guardada en S.
    S.marca = marca;
    var badge = $('lsr-orig-marca');
    if (marca) { badge.textContent = marca; badge.hidden = false; } else { badge.hidden = true; }

    cnt.hidden = false;
    if (S.filtro) {
      cnt.textContent = gs.length + (gs.length === 1 ? ' coincidencia' : ' coincidencias') + ' para "' + S.filtro + '"';
    } else {
      cnt.textContent = todos.length + (todos.length === 1 ? ' color disponible' : ' colores disponibles') +
        (totalSku !== todos.length ? ' · ' + totalSku + ' referencias de fábrica' : '');
    }

    if (!gs.length) {
      var vacio = document.createElement('div');
      vacio.className = 'lsr-refnota';
      vacio.textContent = 'Ningún color o código coincide con eso. Prueba con menos caracteres.';
      box.appendChild(vacio);
      return;
    }

    var conNombre = gs.filter(function (g) { return !g.soloCodigo; });
    var porCodigo = gs.filter(function (g) { return g.soloCodigo; });

    conNombre.forEach(function (g) { box.appendChild(tarjetaColor(g)); });

    if (porCodigo.length) {
      var sep = document.createElement('div');
      sep.className = 'lsr-sep';
      sep.textContent = 'Por código de fábrica';
      box.appendChild(sep);

      var visibles = (S.verCodigos || porCodigo.length <= TOPE_CODIGOS)
        ? porCodigo : porCodigo.slice(0, TOPE_CODIGOS);
      visibles.forEach(function (g) { box.appendChild(tarjetaColor(g)); });

      var restan = porCodigo.length - visibles.length;
      if (restan > 0) {
        var mas = document.createElement('button');
        mas.type = 'button';
        mas.className = 'lsr-vermas';
        mas.textContent = 'Ver los ' + restan + ' códigos restantes';
        mas.addEventListener('click', function () { S.verCodigos = true; pintarColores(); });
        box.appendChild(mas);
      }
    }

    if (S.descartados) {
      console.warn('[lsr] ' + S.descartados + ' referencias ocultas por precio fuera de rango');
    }
  }

  function tarjetaColor(g) {
    var abierto = S.grupo === g.k;
    var card = document.createElement('div');
    card.className = 'lsr-color' + (abierto ? ' on' : '');

    var head = document.createElement('button');
    head.type = 'button';
    head.className = 'lsr-color-head';

    var precio = (g.min === g.max) ? clp(g.min) : ('desde ' + clp(g.min));
    var sub = g.soloCodigo
      ? 'Código de fábrica'
      : (g.items.length === 1 ? ('cód. ' + g.items[0].codigo) : (g.items.length + ' referencias de fábrica'));

    head.innerHTML =
      '<span class="lsr-color-vis"></span>' +
      '<span class="lsr-color-txt"><span class="n"></span><span class="c"></span></span>' +
      '<span class="lsr-color-p"></span>';

    var vis = head.querySelector('.lsr-color-vis');
    if (g.rep.img) {
      var im = document.createElement('img');
      im.src = g.rep.img; im.alt = ''; im.loading = 'lazy';
      vis.appendChild(im);
    } else {
      vis.classList.add('sin-foto');
      vis.textContent = (g.soloCodigo ? '#' : g.nombre.charAt(0).toUpperCase());
    }
    head.querySelector('.n').textContent = g.soloCodigo ? ('Código ' + g.nombre) : g.nombre;
    head.querySelector('.c').textContent = sub;
    head.querySelector('.lsr-color-p').textContent = precio;

    head.addEventListener('click', function () {
      if (g.items.length === 1) {
        S.grupo = g.k; elegirItem(g.items[0], g.items.length);
      } else {
        S.grupo = abierto ? null : g.k;
        if (!abierto) elegirItem(g.items[0], g.items.length);
      }
      pintarTodo();
    });
    card.appendChild(head);

    if (abierto && g.items.length > 1) {
      var lista = document.createElement('div');
      lista.className = 'lsr-refs';
      g.items.forEach(function (it) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lsr-ref' + (S.item && S.item.vid === it.vid ? ' on' : '');
        b.innerHTML = '<span class="cod"></span><span class="pr"></span>';
        b.querySelector('.cod').textContent = 'cód. ' + it.codigo;
        b.querySelector('.pr').textContent = clp(it.pesos);
        b.addEventListener('click', function (e) { e.stopPropagation(); elegirItem(it, g.items.length); pintarTodo(); });
        lista.appendChild(b);
      });
      var nota = document.createElement('div');
      nota.className = 'lsr-refnota';
      nota.textContent = 'El código está grabado en la varilla de tus lentes. Si no lo ves, cualquiera de estas referencias es del mismo color.';
      lista.appendChild(nota);
      card.appendChild(lista);
    }

    return card;
  }

  // ALE, 23-09-2026: refs = cuantas referencias de fabrica comparten el MISMO nombre de
  // color en esta combinacion modelo+pieza+medida. Es el dato que justifica mostrar el
  // codigo: en RB2140 calibre 50 hay cuatro "Gris Degradé" distintos, todos al mismo
  // precio. Cuando se vuelve al original desde el selector de arriba no hay grupo a mano,
  // asi que se conserva el ultimo valor conocido.
  function elegirItem(it, refs) {
    S.via = 'orig';
    S.item = it;
    if (refs != null) S.refs = refs;
    var nombre = arreglarMojibake(String(it.t || '')).replace(/de repuesto para/gi, '').replace(/\s{2,}/g, ' ').trim();
    aplicarSeleccion({
      vid: it.vid,
      nombre: nombre,
      pesos: it.pesos,
      tipo: 'orig',
      marca: S.marca,
      item: it,
      refs: S.refs,
      detalle: colorLindo(it),
      par: esPar(it)
    });
  }

  // ---------- alternativos ----------

  function nivelesDisponibles() {
    var out = [];
    NIVELES.forEach(function (n) {
      var items = ALT.filter(function (a) { return a.nivel === n.id; });
      if (items.length) out.push({ def: n, items: items, desde: Math.min.apply(null, items.map(function (a) { return a.pesos; })) });
    });
    return out;
  }

  function pintarNiveles() {
    var cont = $('lsr-niveles');
    cont.innerHTML = '';
    nivelesDisponibles().forEach(function (n) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lsr-nivel' + (S.nivel === n.def.id ? ' on' : '');
      b.innerHTML =
        '<div class="lsr-nivel-row">' +
        '<span class="ico">' + n.def.ico + '</span>' +
        '<span style="flex-grow:1;"><span class="t"></span><span class="d"></span><span class="u"></span></span>' +
        '<span style="text-align:right;flex-shrink:0;"><span class="p"></span><span class="pn">el par</span></span>' +
        '</div>';
      b.querySelector('.t').textContent = n.def.t;
      b.querySelector('.d').textContent = n.def.d;
      b.querySelector('.u').textContent = n.def.u;
      b.querySelector('.p').textContent = (n.items.length > 1 ? 'desde ' : '') + clp(n.desde);
      b.addEventListener('click', function () {
        S.via = 'alt'; S.nivel = n.def.id;
        var disp = n.items.filter(function (i) { return i.stock; });
        var pool = disp.length ? disp : n.items;
        if (!pool.some(function (i) { return i.sku === S.colorSku; })) S.colorSku = pool[0].sku;
        pintarTodo(); seleccionarAlt();
      });
      cont.appendChild(b);
    });
  }

  function pintarColoresAlt() {
    var box = $('lsr-colores-alt');
    Array.prototype.slice.call(box.querySelectorAll('.lsr-chip')).forEach(function (c) { c.remove(); });
    if (!S.nivel) { box.hidden = true; return; }
    box.hidden = false;
    var items = ALT.filter(function (a) { return a.nivel === S.nivel; });
    var base = items.length ? Math.min.apply(null, items.map(function (a) { return a.pesos; })) : 0;
    items.forEach(function (a) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lsr-chip' + (S.colorSku === a.sku ? ' on' : '');
      b.innerHTML = '<span class="dot" style="background:' + (a.swatch || '#ccc') + '"></span>';
      b.appendChild(document.createTextNode(a.nombre + (a.pesos !== base ? ' · ' + clp(a.pesos) : '')));
      if (!a.stock) b.style.opacity = '.45';
      b.addEventListener('click', function () { S.colorSku = a.sku; S.via = 'alt'; pintarTodo(); seleccionarAlt(); });
      box.appendChild(b);
    });
  }

  function seleccionarAlt() {
    var a = ALT.filter(function (x) { return x.sku === S.colorSku; })[0];
    if (!a) return;
    var n = nivelesDisponibles().filter(function (x) { return x.def.id === a.nivel; })[0];
    var nivelT = n ? n.def.t : '';
    aplicarSeleccion({
      vid: a.vid,
      nombre: CFG.nombreAlt + ' · ' + nivelT + ' · ' + a.nombre,
      pesos: a.pesos,
      tipo: 'alt',
      marca: S.marca,
      item: null,
      refs: 0,
      detalle: [nivelT, a.nombre].filter(Boolean).join(', '),
      // Los alternativos son cristales y se venden por par: el bloque de niveles ya lo
      // dice bajo cada precio.
      par: true
    });
  }

  // ---------- seleccion ----------

  // ALE, 23-09-2026 · BLOQUE DE CONFIRMACION (opcion B)
  // El Decreto N°52 del Ministerio de Economía (vigente 28-02-2025) exige comunicar la
  // exclusión del derecho a retracto antes de la compra, en el mismo lugar donde se
  // informa el precio, de forma inequívoca y destacada. En vez de una advertencia suelta,
  // el bloque le pide al cliente que confirme lo que eligió y usa la exclusión como el
  // porqué. Lo que se confirma sale del SKU (REP-pieza-modelo-codigo-medida), no del
  // titulo: el titulo miente. En RB2140 calibre 50 hay cuatro "Gris Degradé" distintos y
  // en varillas largo 150 hay cinco "Negro" con dos precios; el codigo es lo unico que
  // los separa.
  // OJO: en la via original el dato fino esta en sel.item (S.item), NO en S.medida:
  // S.medida queda en null cuando el modelo tiene una sola medida, que es justo el caso
  // de las varillas largo 150. En la via alternativa S.item es null y no hay codigo de
  // fabrica, porque el color lo pone LENS.
  function aplicarSeleccion(sel) {
    $('lsr-selname').textContent = sel.nombre;
    $('lsr-selprice').textContent = clp(sel.pesos);
    $('lsr-selunit').hidden = !sel.par;

    var cta = $('lsr-cta');
    cta.dataset.vid = sel.vid;
    cta.disabled = false;
    cta.textContent = 'Agregar al carrito';

    var box = $('lsr-selchips');
    box.innerHTML = '';
    var chips = (sel.tipo === 'alt')
      ? [['✓ Fabricado por LENS.', 'hi'], ['✓ Envío a todo Chile', ''], ['✓ Colocación sin costo en tienda', '']]
      : [['✓ Pieza original' + (sel.marca ? ' ' + sel.marca : ' de fábrica'), 'dark'], ['✓ Envío a todo Chile', ''], ['✓ Colocación sin costo en tienda', '']];
    chips.forEach(function (c) {
      var s = document.createElement('span');
      if (c[1]) s.className = c[1];
      s.textContent = c[0];
      box.appendChild(s);
    });

    var esAlt = sel.tipo === 'alt';
    var medida = (!esAlt && sel.item && sel.item.medida) ? sel.item.medida : S.medida;
    var em = etiquetaMedida(S.pieza, medida);

    pintarLinea($('lsr-confirma-ln'), [
      { t: nombrePieza(S.pieza) },
      { pre: sel.marca ? sel.marca + ' ' : '', t: S.modelo || '', b: true },
      em ? { pre: em.k, t: em.v, b: true } : null,
      { t: sel.detalle || '' },
      sel.par ? { t: 'el par', b: true } : null
    ]);

    var codigo = (!esAlt && sel.item) ? String(sel.item.codigo || '') : '';
    if (codigo) {
      $('lsr-confirma-cod-v').textContent = codigo;
      $('lsr-confirma-cod').hidden = false;
      var nota = (sel.refs > 1)
        ? String(CFG.codNota || '').replace('{n}', sel.refs)
        : String(CFG.codNotaUna || '');
      $('lsr-confirma-codnota-t').textContent = nota;
      $('lsr-confirma-codnota').hidden = !nota;
    } else {
      $('lsr-confirma-cod').hidden = true;
      $('lsr-confirma-codnota').hidden = true;
    }

    pintarNegritas($('lsr-confirma-d'), esAlt ? (CFG.avisoAlt || '') : (CFG.avisoOrig || ''));
    $('lsr-confirma').hidden = false;
  }

  function resetSeleccion() {
    S.item = null;
    $('lsr-selname').textContent = 'Todavía no elegiste un repuesto';
    $('lsr-selprice').textContent = '$0';
    $('lsr-selunit').hidden = true;
    // Sin selección no hay precio ni pedido, así que tampoco bloque de confirmación: el
    // aviso solo puede acompañar a un precio concreto (Decreto N°52).
    $('lsr-confirma').hidden = true;
    $('lsr-confirma-ln').innerHTML = '';
    $('lsr-confirma-d').innerHTML = '';
    $('lsr-confirma-cod').hidden = true;
    $('lsr-confirma-cod-v').textContent = '';
    $('lsr-confirma-codnota').hidden = true;
    $('lsr-confirma-codnota-t').textContent = '';
    var cta = $('lsr-cta');
    cta.disabled = true; cta.removeAttribute('data-vid');
    cta.textContent = 'Agregar al carrito';
    $('lsr-selchips').innerHTML = '';
  }

  // ---------- pintar todo ----------

  function pintarTodo() {
    pintarModelos();
    pintarPiezas();
    pintarMedidas();
    pintarColores();

    var mostrarAlt = (S.pieza === 'cristales') && ALT.length > 0 && !S.curvo;
    // ALE, 22-09-2026: cinturon. Si el alternativo dejo de corresponder, volvemos a original y limpiamos.
    if (!mostrarAlt && S.via === 'alt') { S.via = 'orig'; S.nivel = null; S.colorSku = null; resetSeleccion(); }
    $('lsr-box-alt').hidden = !mostrarAlt;
    $('lsr-aviso-curva').hidden = !(S.curvo && S.pieza === 'cristales');

    if (mostrarAlt) {
      $('lsr-alt-desde').textContent = 'desde ' + clp(Math.min.apply(null, ALT.map(function (a) { return a.pesos; })));
      pintarNiveles();
      pintarColoresAlt();
    }

    var esAlt = S.via === 'alt';
    $('lsr-box-orig').classList.toggle('on', !esAlt);
    $('lsr-box-alt').classList.toggle('on', esAlt);
    $('lsr-pick-orig').setAttribute('aria-checked', esAlt ? 'false' : 'true'); // ALE, 22-09-2026: sincroniza el grupo de radio.
    $('lsr-pick-alt').setAttribute('aria-checked', esAlt ? 'true' : 'false'); // ALE, 22-09-2026: sincroniza el grupo de radio.
    $('lsr-orig-drawer').hidden = esAlt;
    $('lsr-alt-drawer').hidden = !esAlt;

    var partes = [];
    if (S.modelo) partes.push('Para tu ' + S.modelo);
    // ALE, 23-09-2026: decia "calibre" siempre, tambien en varillas.
    var emSub = etiquetaMedida(S.pieza, S.medida);
    if (emSub) partes.push(emSub.k + emSub.v);
    $('lsr-paso3-sub').textContent = partes.join(' · ');
  }

  // ---------- reubicar la vista ----------

  function altoHeaderFijo() {
    var cands = document.querySelectorAll('header, .shopify-section-group-header-group > *');
    var alto = 0;
    Array.prototype.slice.call(cands).forEach(function (el) {
      var cs = window.getComputedStyle(el);
      if (cs.position === 'fixed' || cs.position === 'sticky') {
        alto = Math.max(alto, el.getBoundingClientRect().height);
      }
    });
    return Math.min(alto || 70, 160) + 16;
  }

  // Al cambiar entre original y alternativo, una lista larga de colores se
  // oculta o se muestra y la pagina cambia de alto de golpe: el scroll del
  // visitante queda muy abajo y tiene que volver a subir. Despues de repintar
  // reubicamos la vista en la tarjeta que acaba de elegir.
  function traerAlaVista(el) {
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - altoHeaderFijo();
    if (y < 0) y = 0;
    var partida = window.pageYOffset;
    try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (e) { }
    // Verificado 21-09-2026: si el visitante tiene activado "reducir movimiento",
    // el navegador IGNORA behavior:'smooth' y no se mueve nada, sin dar error.
    // Comprobamos y, si no se movio, saltamos sin animacion.
    setTimeout(function () {
      if (Math.abs(window.pageYOffset - partida) < 4 && Math.abs(y - partida) > 4) {
        window.scrollTo(0, y);
      }
    }, 260);
  }

  // ---------- eventos ----------

  $('lsr-go').addEventListener('click', function () { buscar($('lsr-q').value); });
  $('lsr-q').addEventListener('keypress', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); buscar($('lsr-q').value); }
  });

  $('lsr-pick-orig').addEventListener('click', function () {
    S.via = 'orig';
    if (S.item) { elegirItem(S.item); } else { resetSeleccion(); }
    pintarTodo();
    traerAlaVista($('lsr-box-orig'));
  });

  $('lsr-pick-alt').addEventListener('click', function () {
    S.via = 'alt';
    if (!S.nivel) {
      var nd = nivelesDisponibles();
      if (nd.length) {
        S.nivel = nd[0].def.id;
        var pool = nd[0].items.filter(function (i) { return i.stock; });
        S.colorSku = (pool.length ? pool : nd[0].items)[0].sku;
      }
    }
    pintarTodo(); seleccionarAlt();
    traerAlaVista($('lsr-box-alt'));
  });

  // ALE, 22-09-2026: las cabeceras del paso 3 son divs con role="radio"; sin esto no habia forma de llegar con teclado.
  ['lsr-pick-orig', 'lsr-pick-alt'].forEach(function (id) {
    var el = $(id);
    if (!el) return;
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); el.click(); }
    });
  });

  // El link es el UNICO control de la guia: el <summary> del <details> esta
  // oculto por CSS, porque antes se veian dos textos haciendo lo mismo.
  // ALE, 23-09-2026: ahora hay dos links que abren la misma guia — el del paso 1 y el
  // del bloque de confirmacion, al lado del codigo de fabrica.
  ['lsr-guia-link', 'lsr-confirma-guia'].forEach(function (id) {
    var gl = $(id);
    if (!gl) return;
    gl.setAttribute('aria-expanded', 'false');
    gl.addEventListener('click', function (e) {
      var g = $('lsr-guia');
      if (!g) return;
      e.preventDefault();
      g.open = !g.open;
      gl.setAttribute('aria-expanded', g.open ? 'true' : 'false');
      if (g.open) traerAlaVista(g);
    });
  });

  $('lsr-cta').addEventListener('click', function () {
    var cta = $('lsr-cta');
    var vid = cta.dataset.vid;
    if (!vid) return;
    cta.disabled = true; cta.textContent = 'Agregando...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      cta.textContent = '¡Agregado!';
      window.location.href = '/cart';
    }).catch(function () {
      cta.disabled = false;
      cta.textContent = 'Error al agregar';
    });
  });

  // ---------- entrada por ?q= ----------
  (function () {
    var q = '';
    try { q = new URLSearchParams(window.location.search).get('q') || ''; } catch (e) { return; }
    q = q.split(' -product_type:')[0].split(' -tag:')[0].trim().slice(0, 40);
    if (q && /\d/.test(q)) {
      $('lsr-q').value = q;
      buscar(q);
    }
  })();

})();
